import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { AwsCaptchaDirective } from './aws-captcha.directive';

@Component({
  selector: 'thehubz-captcha-popup',
  templateUrl: './captcha-popup.component.html',
  styleUrls: ['./captcha-popup.component.scss'],
  standalone: true,
  imports: [CommonModule, MatIconModule, MatDialogModule, AwsCaptchaDirective],
})
export class CaptchaPopupComponent {
  static loadAWSScript() {
    let isFound = false;
    const scripts = document.getElementsByTagName('script');
    for (const script of scripts) {
      if (script && script.getAttribute('src') != null && script.getAttribute('src')?.includes('1f892b649427/jsapi.js')) {
        isFound = true;
      }
    }

    if (!isFound) {
      const dynamicScript = 'https://1f892b649427.us-east-1.captcha-sdk.awswaf.com/1f892b649427/jsapi.js';
      const node = document.createElement('script');
      node.src = dynamicScript;
      node.type = 'text/javascript';
      node.async = false;
      document.getElementsByTagName('head')[0].appendChild(node);
    }
  }

  constructor(public matDialogRef: MatDialogRef<CaptchaPopupComponent>) {}

  onCancelClick() {
    this.matDialogRef.close({
      success: false,
    });
  }

  captchaSuccess(token: string) {
    this.matDialogRef.close({
      success: true,
      token,
    });
  }
}
